import UserAgent from "../../../../util/UserAgentUtil";
import * as urlUtil from "../../../../util/UrlUtil";
import {getClickAllEvent} from "../../../../util/Ga4EventUtil";

export const moveToTopPage = (isAppli, elText) => {
    const sendLogCallback = (url) => getClickAllEvent(url, elText)
    if (isAppli) {
        // iOSのWebView内からUniversal Linkで遷移すると外部ブラウザ(Safari)が開いてしまう
        // 不具合があるため、iOSではDeep Linkを使用してアプリのHOMEに遷移する
        const userAgent = new UserAgent();
        if (userAgent.isIOS) {
            const url = urlUtil.pictlinkAppSchemeUrlUtil.iOSDeepLink('home');
            sendLogCallback(url);
            location.href = url;
        } else if (userAgent.isAndroid) {
            const url = urlUtil.pictlinkAppSchemeUrlUtil.appUniversalLink('home');
            sendLogCallback(url);
            location.href = url;
        }
    } else {
        const url = urlUtil.servletUrlUtil.topUrl();
        sendLogCallback(url);
        location.href = url;
    }
}
